var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseNovotalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.822,
    height: 93,
    viewBox: "0 0 185.822 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(-1022.114 -2100)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 8.747,
    height: 5.177,
    transform: "matrix(0.974, -0.228, 0.228, 0.974, 1130.301, 2170.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M447.308,500.393l4.373,11.692-1.607.625-5.087-11.424A1.245,1.245,0,1,1,447.308,500.393Z",
    transform: "translate(689.583 1670.651)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M448.435,515.481l5.355-1.339a.778.778,0,0,0,.536-.714l.089-1.785c0-.357-.178-.535-.535-.446l-5.355,1.339a.777.777,0,0,0-.536.714l-.089,1.785a.5.5,0,0,0,.536.446Zm.536-1.785c-.089,0-.089-.089-.089-.179v-.535a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.178v.535a.312.312,0,0,1-.089.179l-1.25.268Zm3.213-.8c-.089,0-.089-.089-.089-.179v-.535a.311.311,0,0,1,.089-.179l1.249-.268c.089,0,.089.089.089.178v.535a.311.311,0,0,1-.089.179l-1.249.268Zm-3.213,2.053c-.089,0-.089-.089-.089-.178v-.536a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.178v.535a.312.312,0,0,1-.089.179l-1.25.268Zm3.213-.8c-.089,0-.089-.089-.089-.179v-.535a.312.312,0,0,1,.089-.179l1.249-.268c.089,0,.089.089.089.179v.535a.312.312,0,0,1-.089.179Z",
    transform: "translate(689.259 1669.397)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M445.68,494.4a5.98,5.98,0,1,1-5.98,5.98,5.98,5.98,0,0,1,5.98-5.98Zm0,2.321a3.659,3.659,0,1,0,3.659,3.659A3.676,3.676,0,0,0,445.68,496.72Z",
    transform: "translate(690.141 1671.2)",
    fill: "#00b7e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M448.836,495.435l-1.606,3.213a1.789,1.789,0,0,0,.8,2.41l3.213,1.606-.535,1.071-3.213-1.606a1.789,1.789,0,0,0-2.41.8l-1.606,3.213-1.071-.535,1.607-3.213a1.789,1.789,0,0,0-.8-2.41L440,498.381l.536-1.071,3.213,1.606a1.789,1.789,0,0,0,2.41-.8l1.607-3.213A2.036,2.036,0,0,1,448.836,495.435Z",
    transform: "translate(690.109 1671.146)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M437.874,488.138l5,2.321a1.038,1.038,0,0,0,.893-.179l1.16-1.339c.178-.268.178-.535-.089-.625l-5-2.321a1.038,1.038,0,0,0-.893.179l-1.16,1.339a.377.377,0,0,0,.089.625Zm1.517-.982c-.089,0-.089-.089,0-.178l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.178l-.357.446a.328.328,0,0,1-.268.089l-1.16-.536Zm3.035,1.339c-.089,0-.089-.089,0-.178l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.178l-.357.446a.328.328,0,0,1-.268.089l-1.16-.536Zm-3.749-.446c-.089,0-.089-.089,0-.179l.357-.446a.276.276,0,0,1,.178-.089l1.16.535c.089,0,.089.089,0,.179l-.357.446a.328.328,0,0,1-.268.089l-1.071-.536Zm2.945,1.428c-.089,0-.089-.089,0-.179l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.179l-.357.446a.328.328,0,0,1-.268.089Z",
    transform: "translate(690.36 1672.107)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M444.627,500.37l-3.927-11.6,1.964-.268,4.373,11.156C447.572,501.084,445.163,501.977,444.627,500.37Z",
    transform: "translate(690.033 1671.834)",
    fill: "#544132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M446.314,501.828a.7.7,0,0,0,.714-.714.768.768,0,0,0-.714-.714.714.714,0,0,0,0,1.428Z",
    transform: "translate(689.507 1670.555)",
    fill: "#9cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M378.6,493.9l58.638.982v.536L378.6,494.346Z",
    transform: "translate(696.708 1671.254)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M378,507.325l59.174-.089V506.7L378,506.789Z",
    transform: "translate(696.773 1669.878)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M412.2,463.092c.8-.268,1.607-.535,2.5-.892.268.714.893,2.5,1.16,3.213a3.04,3.04,0,0,1-2.856-.357A12.913,12.913,0,0,1,412.2,463.092Z",
    transform: "translate(693.097 1674.661)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M387.747,495.148a1.652,1.652,0,0,1-2.588-2.053l61.048-33.469a1.652,1.652,0,0,1,2.588,2.053Z",
    transform: "translate(696.04 1675.003)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M380.8,498l58.549.268v4.106l-58.549-.268Z",
    transform: "translate(696.472 1670.813)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M376.739,504.872l8.39-1.874-1.16-5-8.568,2.053Z",
    transform: "translate(697.052 1670.813)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M496.546,475.7l1.16,18.564-.357.089L496.1,475.789Z",
    transform: "translate(684.079 1673.21)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M492.646,476.4l4.463,17.85-.357.089-4.552-17.85Z",
    transform: "translate(684.498 1673.134)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M488.757,477.9l10.71,16.155-.268.268-10.8-16.154Z",
    transform: "translate(684.906 1672.973)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M485.768,480.5l13.12,13.566-.357.268L485.5,480.857Z",
    transform: "translate(685.218 1672.694)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M483.457,483.1l12.674,13.655-.268.268L483.1,483.368Z",
    transform: "translate(685.476 1672.414)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M480.778,486l14.9,11.067-.268.357L480.6,486.357Z",
    transform: "translate(685.745 1672.103)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M478.789,489.6,497,495.134l-.089.446L478.7,490.046Z",
    transform: "translate(685.949 1671.716)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M478.1,493.6l18.564,1.517-.089.357L478.1,493.957Z",
    transform: "translate(686.013 1671.286)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M477.589,496.9l18.564,2.41v.446l-18.654-2.5Z",
    transform: "translate(686.078 1670.931)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M477.5,500.692l18.564-.893v.357l-18.564.982Z",
    transform: "translate(686.078 1670.619)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M478.2,503.976l17.136-7.676.179.357-17.136,7.676Z",
    transform: "translate(686.003 1670.995)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M480.2,507.032,495.462,496.5l.268.357-15.262,10.532Z",
    transform: "translate(685.788 1670.974)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M482.3,509.928l15.976-9.728.178.357-15.976,9.728Z",
    transform: "translate(685.562 1670.576)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M484.7,512.717,498.534,500.4l.268.268-13.834,12.406Z",
    transform: "translate(685.304 1670.555)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M487.9,514.89l8.3-16.69.446.268-8.39,16.6Z",
    transform: "translate(684.96 1670.791)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M491.6,516.161l5.087-17.761.446.178-5.087,17.672Z",
    transform: "translate(684.562 1670.77)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 0.446,
    height: 18.654,
    transform: "translate(1183.856 2148.943) rotate(-2.731)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M504.245,476l-2.5,18.3H501.3l2.5-18.3Z",
    transform: "translate(683.52 1673.177)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M507.45,477.278l-9.193,16.244-.357-.179,9.193-16.244Z",
    transform: "translate(683.885 1673.059)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M510.327,479.668l-11.87,14.1-.357-.268,11.87-14.1Z",
    transform: "translate(683.864 1672.812)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M512.41,481.078l-10.353,15.53-.357-.179,10.353-15.53Z",
    transform: "translate(683.477 1672.651)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M515.109,483.668l-12.852,13.3-.357-.357L514.841,483.4Z",
    transform: "translate(683.455 1672.382)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M517.136,486.957l-16.958,8.122-.179-.357,16.958-8.122Z",
    transform: "translate(683.659 1672.038)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M518.218,490.757l-18.029,4.463-.089-.357,18.029-4.463Z",
    transform: "translate(683.649 1671.63)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 18.743,
    height: 0.446,
    transform: "translate(1185.482 2169.579) rotate(-13.863)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 18.564,
    height: 0.446,
    transform: "translate(1185.618 2169.71) rotate(-3.413)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M520.221,501.644l-18.921-5,.179-.446,18.921,5.087Z",
    transform: "translate(683.52 1671.006)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M518.736,504.9,501.6,496.957l.268-.357L519,504.543Z",
    transform: "translate(683.487 1670.963)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M517.058,507.9,500.1,499.957l.178-.357,16.958,7.943Z",
    transform: "translate(683.649 1670.641)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M515.183,510.867,500.1,500.157l.268-.357,15.083,10.8Z",
    transform: "translate(683.649 1670.619)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M512.785,513.187,502.7,497.568l.357-.268,10.085,15.708Z",
    transform: "translate(683.369 1670.888)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M509.562,514.826,502.6,497.689l.357-.089,7.051,17.047Z",
    transform: "translate(683.38 1670.856)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M495.4,516.75l5.355-17.85.357.089-5.355,17.85Z",
    transform: "translate(684.154 1670.716)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 18.475,
    height: 0.446,
    transform: "translate(1183.084 2188.168) rotate(-83.892)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M502.9,517.329l-5-17.939.357-.089,5,17.94Z",
    transform: "translate(683.885 1670.673)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M506.222,516.079l-8.122-16.6.357-.178,8.122,16.6Z",
    transform: "translate(683.864 1670.673)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M496.855,470.3A24.455,24.455,0,1,1,472.4,494.755,24.492,24.492,0,0,1,496.855,470.3Zm0,4.552a19.9,19.9,0,1,0,19.9,19.9A20.276,20.276,0,0,0,496.855,474.852Z",
    transform: "translate(686.626 1673.79)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M497.242,473.9A21.242,21.242,0,1,1,476,495.142,21.235,21.235,0,0,1,497.242,473.9Zm0,1.874a19.368,19.368,0,1,0,19.368,19.368A19.35,19.35,0,0,0,497.242,475.774Z",
    transform: "translate(686.239 1673.403)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M343.146,475.7l1.16,18.564-.446.089-1.16-18.564Z",
    transform: "translate(700.567 1673.21)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M339.246,476.4l4.463,17.85-.357.089-4.552-17.85Z",
    transform: "translate(700.986 1673.134)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M335.357,477.9l10.889,15.173-.357.178L335,478.168Z",
    transform: "translate(701.394 1672.973)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M332.368,480.5l13.388,12.763-.268.357L332.1,480.857Z",
    transform: "translate(701.706 1672.694)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M330.057,483.1l12.674,13.655-.268.268L329.7,483.368Z",
    transform: "translate(701.964 1672.414)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M327.368,486l14.905,11.067-.268.357-14.9-11.067Z",
    transform: "translate(702.244 1672.103)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M325.389,489.6l18.029,4.909-.089.446L325.3,490.046Z",
    transform: "translate(702.437 1671.716)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M324.7,493.6l18.564,1.517-.089.357L324.7,493.957Z",
    transform: "translate(702.502 1671.286)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M324.189,496.9l18.564,2.41v.446l-18.654-2.5Z",
    transform: "translate(702.566 1670.931)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M324.1,500.692l18.564-.893v.357l-18.564.982Z",
    transform: "translate(702.566 1670.619)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M324.8,503.976l17.136-7.676.089.357-17.047,7.676Z",
    transform: "translate(702.491 1670.995)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M326.8,507.032,342.062,496.5l.268.357-15.262,10.532Z",
    transform: "translate(702.276 1670.974)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M328.9,509.928l15.976-9.728.179.357-15.976,9.728Z",
    transform: "translate(702.05 1670.576)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M331.3,512.717,345.134,500.4l.268.268-13.834,12.406Z",
    transform: "translate(701.792 1670.555)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M334.5,514.89l8.3-16.69.446.268-8.39,16.6Z",
    transform: "translate(701.448 1670.791)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M338.2,516.161l5.087-17.761.446.178-5.087,17.672Z",
    transform: "translate(701.05 1670.77)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 0.446,
    height: 18.654,
    transform: "translate(1046.848 2148.948) rotate(-2.731)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M350.845,476l-2.5,18.3H347.9l2.5-18.3Z",
    transform: "translate(700.008 1673.177)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M354.05,477.278l-9.193,16.244-.357-.179,9.193-16.244Z",
    transform: "translate(700.373 1673.059)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M356.927,479.668l-11.87,14.1-.357-.268,11.87-14.1Z",
    transform: "translate(700.352 1672.812)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M359.01,481.078l-10.353,15.53-.357-.179,10.353-15.53Z",
    transform: "translate(699.965 1672.651)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M361.709,483.668l-12.852,13.3-.357-.357L361.441,483.4Z",
    transform: "translate(699.943 1672.382)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M363.725,486.957l-17.047,7.765-.178-.357,17.047-7.765Z",
    transform: "translate(700.158 1672.038)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M364.818,490.757l-18.029,4.463-.089-.357,18.029-4.463Z",
    transform: "translate(700.137 1671.63)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 18.743,
    height: 0.446,
    transform: "translate(1048.566 2169.572) rotate(-13.863)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 18.564,
    height: 0.446,
    transform: "translate(1048.71 2169.71) rotate(-3.413)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M366.961,501.558,349.2,495.846l.089-.446,17.85,5.8Z",
    transform: "translate(699.868 1671.092)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M365.444,504.793,349.2,495.957l.178-.357,16.333,8.836Z",
    transform: "translate(699.868 1671.071)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M363.658,507.9,346.7,499.957l.178-.357,16.958,7.943Z",
    transform: "translate(700.137 1670.641)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M361.783,510.867,346.7,500.157l.268-.357,15.083,10.8Z",
    transform: "translate(700.137 1670.619)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M359.385,513.187,349.3,497.568l.357-.268,10.085,15.708Z",
    transform: "translate(699.857 1670.888)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M356.151,514.826,349.1,497.689l.446-.089,7.051,17.047Z",
    transform: "translate(699.879 1670.856)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M342,516.75l5.355-17.85.357.089-5.355,17.85Z",
    transform: "translate(700.642 1670.716)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 18.475,
    height: 0.446,
    transform: "translate(1046.159 2188.153) rotate(-83.892)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M349.5,517.329l-5-17.939.357-.089,5,17.94Z",
    transform: "translate(700.373 1670.673)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M352.822,516.079l-8.122-16.6.357-.178,8.122,16.6Z",
    transform: "translate(700.352 1670.673)",
    fill: "#e0e3e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M343.455,470.3A24.455,24.455,0,1,1,319,494.755,24.492,24.492,0,0,1,343.455,470.3Zm0,4.552a19.9,19.9,0,1,0,19.9,19.9A20.276,20.276,0,0,0,343.455,474.852Z",
    transform: "translate(703.114 1673.79)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M343.842,473.9A21.242,21.242,0,1,1,322.6,495.142,21.235,21.235,0,0,1,343.842,473.9Zm0,1.874a19.368,19.368,0,1,0,19.368,19.368A19.35,19.35,0,0,0,343.842,475.774Z",
    transform: "translate(702.727 1673.403)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    cx: 4.73,
    cy: 4.73,
    r: 4.73,
    transform: "translate(1041.839 2163.815)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M352.063,512.227a1.964,1.964,0,1,0-1.964-1.964A2.043,2.043,0,0,0,352.063,512.227Z",
    transform: "translate(699.771 1669.706)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M350.34,502.712a4.318,4.318,0,0,0-3.035-.714,15.627,15.627,0,0,0-4.106.446v1.874l1.517,1.339.8-1.339h2.945Z",
    transform: "translate(700.513 1670.385)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M345.78,499.041a1.075,1.075,0,0,1,.178-2.142l26.686,2.321a1.075,1.075,0,1,1-.178,2.142Z",
    transform: "translate(700.342 1670.932)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M447.247,497.193a1.652,1.652,0,1,1-2.588-2.053l31.327-38.914a1.652,1.652,0,1,1,2.588,2.053Z",
    transform: "translate(689.645 1675.369)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M373.168,472.119c-.536.178-1.7-1.339-1.874-1.874a1.132,1.132,0,0,1,.714-1.428l97.016-13.923a1.132,1.132,0,0,1,1.428.714c.179.535.357,2.41-.178,2.588Z",
    transform: "translate(697.499 1675.452)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M485.093,466.821a1.129,1.129,0,0,1,2.142-.714l3.035,8.568-2.053.714Z",
    transform: "translate(685.267 1674.323)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M367.442,452.9l12.227,37.664a1.129,1.129,0,1,1-2.142.714L365.3,453.614Z",
    transform: "translate(698.138 1675.661)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 28.293,
    height: 0.536,
    transform: "translate(1051.709 2181.483) rotate(-9.486)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 0.536,
    height: 28.293,
    transform: "translate(1049.824 2166.057) rotate(-89.716)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M482.1,462.292c.8-.268,1.607-.536,2.5-.893.268.714.893,2.5,1.16,3.213a3.04,3.04,0,0,1-2.856-.357A10,10,0,0,1,482.1,462.292Z",
    transform: "translate(685.583 1674.747)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M483.7,464.082l2.856-.982,1.428,4.373-2.767.982Z",
    transform: "translate(685.411 1674.564)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M477.3,449.5l2.5-.8,1.339,4.195-2.41.8Z",
    transform: "translate(686.099 1676.112)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M499.588,500.677A2.588,2.588,0,1,0,497,498.088,2.59,2.59,0,0,0,499.588,500.677Z",
    transform: "translate(683.982 1671.082)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M496.9,493.4l.268.268c1.339,1.339,1.874,2.142,3.392,2.767a1.732,1.732,0,0,1,.179,2.678h0a1.859,1.859,0,0,1-2.678-.179l-1.071-1.249V493.4Z",
    transform: "translate(683.993 1671.307)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 1.696,
    height: 2.41,
    transform: "translate(1061.078 2124.561) rotate(-11.958)",
    fill: "#00b7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M354.384,447.135c-.089-.446-.357-1.7.268-2.321s1.607-.714,3.124-.714c1.517.089,6.515.357,8.479.357a49.209,49.209,0,0,1,6.158-.089,2.688,2.688,0,0,1,1.964,2.767,33.851,33.851,0,0,1-5.177-.179,10.473,10.473,0,0,0-5.891,1.25,4.971,4.971,0,0,1-4.552.446C358.132,448.473,355.812,447.224,354.384,447.135Z",
    transform: "translate(699.325 1676.606)",
    fill: "#ba4c27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M490.131,474.6l7.229,20.082a1.186,1.186,0,0,1-2.231.8L487.9,475.4Z",
    transform: "translate(684.96 1673.328)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M382.6,500.393l4.373,11.692-1.607.625-5.087-11.424A1.246,1.246,0,1,1,382.6,500.393Z",
    transform: "translate(696.541 1670.651)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 1.696,
    height: 2.41,
    transform: "translate(1119.152 2125.025) rotate(-11.958)",
    fill: "#00b7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M383.735,515.481l5.355-1.339a.778.778,0,0,0,.535-.714l.089-1.785c0-.357-.179-.535-.536-.446l-5.355,1.339a.777.777,0,0,0-.536.714l-.089,1.785c0,.268.178.446.535.446Zm.446-1.785c-.089,0-.089-.089-.089-.179v-.535a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.178v.535a.312.312,0,0,1-.089.179l-1.25.268Zm3.213-.8c-.089,0-.089-.089-.089-.179v-.535a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.178v.535a.312.312,0,0,1-.089.179l-1.25.268Zm-3.213,2.053c-.089,0-.089-.089-.089-.178v-.536a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.178v.535a.312.312,0,0,1-.089.179l-1.25.268Zm3.213-.8c-.089,0-.089-.089-.089-.179v-.535a.312.312,0,0,1,.089-.179l1.25-.268c.089,0,.089.089.089.179v.535a.312.312,0,0,1-.089.179Z",
    transform: "translate(696.214 1669.397)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M499.792,499.085a.893.893,0,1,0-.893-.892A.894.894,0,0,0,499.792,499.085Z",
    transform: "translate(683.778 1670.888)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M350.628,512.339c.714-.178,2.678-.357,3.3-1.964s-2.142-.714-2.142-1.964c-.089-1.249.446-3.035.179-4.106a3.23,3.23,0,0,0-.892-1.606l-1.874,1.606a4.641,4.641,0,0,1,1.249,2.142c.089.893.268,4.82.268,4.82S349.914,511.8,350.628,512.339Z",
    transform: "translate(699.868 1670.308)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M346.677,495.982a1.073,1.073,0,0,1-1.517-1.517l23.205-23.205a1.073,1.073,0,0,1,1.517,1.517Z",
    transform: "translate(700.338 1673.723)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M346.164,499.427a1.964,1.964,0,1,0-1.964-1.964A1.981,1.981,0,0,0,346.164,499.427Z",
    transform: "translate(700.406 1671.082)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M365.087,449.4l-2.588.446a2.53,2.53,0,0,0,.178,1.25,2.277,2.277,0,0,0,1.7,1.517c.982.178.982-.089,1.16.357l1.428-.446Z",
    transform: "translate(698.44 1676.037)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M478.5,454.16v-.089L481.624,453h0l3.213,8.39-3.124,1.071Z",
    transform: "translate(685.97 1675.65)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M346.3,498.406a.8.8,0,1,0-.8-.8A.8.8,0,0,0,346.3,498.406Z",
    transform: "translate(700.266 1670.942)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M380.88,494.4a5.98,5.98,0,1,1-5.98,5.98,5.98,5.98,0,0,1,5.98-5.98Zm0,2.321a3.659,3.659,0,1,0,3.659,3.659A3.619,3.619,0,0,0,380.88,496.72Z",
    transform: "translate(697.106 1671.2)",
    fill: "#00b7e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M384.136,495.435l-1.606,3.213a1.789,1.789,0,0,0,.8,2.41l3.213,1.606-.536,1.071-3.213-1.606a1.789,1.789,0,0,0-2.41.8l-1.607,3.213-1.071-.535,1.607-3.213a1.789,1.789,0,0,0-.8-2.41l-3.213-1.607.536-1.071,3.213,1.606a1.789,1.789,0,0,0,2.41-.8l1.607-3.213A3.017,3.017,0,0,1,384.136,495.435Z",
    transform: "translate(697.063 1671.146)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M373.17,488.138l5,2.321a1.038,1.038,0,0,0,.893-.179l1.16-1.339c.178-.268.178-.535-.089-.625l-5-2.321a1.038,1.038,0,0,0-.893.179l-1.16,1.339a.346.346,0,0,0,.089.625Zm1.517-.982c-.089,0-.089-.089,0-.178l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.178l-.357.446a.328.328,0,0,1-.268.089l-1.16-.536Zm3.035,1.339c-.089,0-.089-.089,0-.178l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.178l-.357.446a.328.328,0,0,1-.268.089l-1.16-.536Zm-3.838-.446c-.089,0-.089-.089,0-.179l.357-.446a.328.328,0,0,1,.268-.089l1.16.535c.089,0,.089.089,0,.179l-.357.446a.328.328,0,0,1-.268.089l-1.16-.536Zm3.035,1.428c-.089,0-.089-.089,0-.179l.357-.446a.328.328,0,0,1,.268-.089l1.16.536c.089,0,.089.089,0,.179l-.357.446a.276.276,0,0,1-.179.089Z",
    transform: "translate(697.319 1672.107)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M379.927,500.37,376,488.768l1.964-.268,4.373,11.156C382.872,501.084,380.463,501.977,379.927,500.37Z",
    transform: "translate(696.988 1671.834)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M381.514,501.828a.7.7,0,0,0,.714-.714.768.768,0,0,0-.714-.714.7.7,0,0,0-.714.714A.768.768,0,0,0,381.514,501.828Z",
    transform: "translate(696.472 1670.555)",
    fill: "#9cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M431.942,452.9l13.388,41.234a1.129,1.129,0,1,1-2.142.714L429.8,453.614Z",
    transform: "translate(691.205 1675.661)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M418.884,447.135c-.089-.446-.357-1.7.268-2.321s1.607-.714,3.124-.714c1.517.089,6.515.357,8.479.357a49.21,49.21,0,0,1,6.158-.089,2.688,2.688,0,0,1,1.964,2.767,33.851,33.851,0,0,1-5.177-.179,10.473,10.473,0,0,0-5.891,1.25,4.97,4.97,0,0,1-4.552.446C422.632,448.473,420.312,447.224,418.884,447.135Z",
    transform: "translate(692.393 1676.606)",
    fill: "#ba4c27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M429.586,449.4l-2.588.535a2.53,2.53,0,0,0,.178,1.25,2.277,2.277,0,0,0,1.7,1.517c.982.178.982-.089,1.16.357l1.428-.446Z",
    transform: "translate(691.508 1676.037)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M407.4,450.292l2.5-.893,1.339,4.195-2.41.893Z",
    transform: "translate(693.613 1676.037)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M410.149,450.384l-1.25-1.964,3.749-2.321,1.249,1.964Z",
    transform: "translate(693.451 1676.391)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M407.376,451.47a5.742,5.742,0,0,0,3.035-.8,21.742,21.742,0,0,0-.982-2.678,2.766,2.766,0,0,0-2.945,1.071.828.828,0,0,0,.357,1.16A.81.81,0,0,0,407.376,451.47Z",
    transform: "translate(693.726 1676.198)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M408.6,454.96v-.089l3.124-1.071h0l3.213,8.39-3.124,1.071Z",
    transform: "translate(693.484 1675.564)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M413.439,448.477a1.339,1.339,0,1,0-1.339-1.339A1.373,1.373,0,0,0,413.439,448.477Z",
    transform: "translate(693.107 1676.424)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M415.942,465.2l4.195,12.763a1.129,1.129,0,1,1-2.142.714L413.8,465.914Z",
    transform: "translate(692.925 1674.338)",
    fill: "#9bd6e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M480.049,449.584l-1.25-1.964,3.749-2.321,1.25,1.964Z",
    transform: "translate(685.938 1676.477)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M477.276,450.67a5.741,5.741,0,0,0,3.035-.8,21.733,21.733,0,0,0-.982-2.678,2.766,2.766,0,0,0-2.945,1.071.828.828,0,0,0,.357,1.16A.81.81,0,0,0,477.276,450.67Z",
    transform: "translate(686.212 1676.283)",
    fill: "#f08920",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M484.075,447.127a1.075,1.075,0,0,1-1.607-1.428,5.529,5.529,0,0,1,3.213-1.607,4.438,4.438,0,0,1,1.874.089,3.95,3.95,0,0,1,1.785.982,5.19,5.19,0,0,1,1.517,3.213,1.131,1.131,0,0,1-2.231.357,3.061,3.061,0,0,0-.8-1.874,1.824,1.824,0,0,0-.8-.446,2.175,2.175,0,0,0-1.071,0A2.361,2.361,0,0,0,484.075,447.127Z",
    transform: "translate(685.571 1676.613)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 1.339,
    cy: 1.339,
    r: 1.339,
    transform: "translate(1167.404 2121.654) rotate(-9.218)",
    fill: "#f08920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M375.5,443.2Z",
    transform: "translate(697.041 1676.703)",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M368.8,441Z",
    transform: "translate(697.761 1676.94)",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M375.3,420.9Z",
    transform: "translate(697.063 1679.1)",
    fill: "#fc0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseNovotalk);
export default __webpack_public_path__ + "static/media/course_novotalk.1b0c70ddce0858bd609e1af79f1fcb8b.svg";
export { ForwardRef as ReactComponent };